import Api from './Api';

class TipoJulgamentoApi extends Api {
    async recuperarTiposJulgamento() {
        let result = await this.fetch(this.configuracao.urlBaseSessao + '/tipos-julgamentos/');
        return result.data;
    }
}

export default TipoJulgamentoApi;
